import React from 'react';
import logo from './logo.svg';
import './App.scss';
import { Header } from './components/interface/Header';
import { Footer } from './components/interface/Footer';
import { Router } from './core/Router';
import content from './content/content.json';
import EventDispatcher from './core/EventDispatcher';

export const GLOBAL:{
	content:any,
	router: Router
} = {
	content: content,
	router: null,
}

export const GlobalDispatcher = new EventDispatcher();

function App() {
	return (
		<div className="App">
			<Header></Header>
			<main>
				<Router content={content}></Router>
			</main>
			<Footer></Footer>
		</div>
	);
}

export default App;
